Vue.component("MpModuleAc", {
    props: {
        hasZones: Number,
    },
    data: function() {
        return {
            currentTab: 0,
            selected: '1',
        };
    },
    computed: {},
    methods: {

        showTab: function(tabIndex, ev) {
            var _this = this;

            this.currentTab = tabIndex;

            if (tabIndex == 1) {
                Vue.nextTick(function () {
                    _this.showZone();
                });
            }
        },

        showZone: function() {
            var currentZone,
                newZone;

            currentZone = document.querySelector('.zone_'+this.selected);
            currentZone.classList.add('hidden');

            this.selected = document.getElementById('competency_zone_selector').value;
            newZone = document.querySelector('.zone_'+this.selected);
            newZone.classList.remove('hidden');
        },

        init: function() {

        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <section class="tabs promo promo--fullwidth">\
        <div class="tabs__list-wrapper">\
            <slot name="tabs" v-bind:currentTab="currentTab" v-bind:showTab="showTab"></slot>\
        </div>\
\
        <div class="tabs__content">\
            <div class="acprices" id="country_data_content" v-if="currentTab == 0">\
                <slot name="national"></slot>\
            </div>\
            <div class="acprices" id="zone_data_content" v-if="hasZones && currentTab == 1">\
                <slot name="zones" v-bind:selected="selected" v-bind:showZone="showZone"></slot>\
            </div>\
        </div>\
    </section>',
});
